'use client';

import { createContext, useContext, PropsWithChildren } from 'react';
import useAskAiChat from '../hooks/useAskAiChat';

type AskAiChatContextType = ReturnType<typeof useAskAiChat>['chat'];
type AskAiChatListContextType = ReturnType<typeof useAskAiChat>['chatList'];

const AskAiChatContext = createContext<AskAiChatContextType | null>(null);
const AskAiChatListContext = createContext<AskAiChatListContextType | null>(null);

export const useAskAiChatContext = (): AskAiChatContextType => {
  const context = useContext(AskAiChatContext);

  if (!context) {
    throw new Error('useAskAiChatContext must be used within an AskAiChatProvider');
  }

  return context;
};

export const useAskAiChatListContext = (): AskAiChatListContextType => {
  const context = useContext(AskAiChatListContext);

  if (!context) {
    throw new Error('useAskAiChatListContext must be used within an AskAiChatProvider');
  }

  return context;
};

const AskAiChatProvider = ({ children }: PropsWithChildren) => {
  const { chat, chatList } = useAskAiChat();

  return (
    <AskAiChatContext.Provider value={ chat }>
      <AskAiChatListContext.Provider value={ chatList }>
        { children }
      </AskAiChatListContext.Provider>
    </AskAiChatContext.Provider>
  );
};

export default AskAiChatProvider;
